import { intercept } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Prompt, Redirect } from 'react-router';
import { Button, Col, FormGroup, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import DataTable from 'src/Components/DataTable';
import { UserStore } from 'src/Stores/User/UserStore';
import DeepCopy from 'src/UtilityFunctions/DeepCopy';
import { GroupEmail, IContractor } from '../../../../Interfaces/AdminInterface';
import ButtonRow from '../../../ButtonRow';
import { EButton, EInput } from '../../../EInput';



@inject('stores')
@observer
class AdminContractorDetails extends React.Component {

    public props: any;
    public contractor: IContractor = new IContractor();
    public contractorDisposer: any;
    public adminStore: any;
    public MessageStore: any;
    private UserStore: UserStore;
    private contractorGroupEmailHeader = [
        "Group Email",
        "Description",
    ];

    public state = {
        contractor: this.contractor,
        contractorId: '',
        editingGroupEmail: false,
        groupEmail: new GroupEmail(),
        groupEmailModal: false,
        isDirty: false,
        redirect: false,
        rowIndex: 0,
    };

    constructor(props: any) {
        super(props);

        this.adminStore = this.props.stores.AdminStore;
        this.MessageStore = this.props.stores.MessageStore;
        this.UserStore = this.props.stores.UserStore;
        this.handleChange = this.handleChange.bind(this);
        this.handleSaveContractor = this.handleSaveContractor.bind(this);
        this.removeContractor = this.removeContractor.bind(this);
    }

    public componentDidMount() {
        this.createDisposers();

        this.setState({
            contractorId: this.props.match.params.id,
        }, () => {
            if ( this.state.contractorId !== 'new' ) {
                this.adminStore.getContractor(this.props.match.params.id);
            }
        });
    }

    public componentWillUnmount() {
        this.clearDisposers();
    }

    public createDisposers() {
        this.contractorDisposer = intercept(this.adminStore, 'contractor', (change: any) => {
            this.setState({
                contractor: change.newValue
            });

            return change;
        });
    }

    public clearDisposers() {
        this.contractorDisposer();
    }

    private formatContractorGroupEmailsData = () => {
        const contractorGroupEmails = this.state.contractor.groupEmails;
        const rows = [] as any[];
        contractorGroupEmails.forEach(groupEmail => {
            const tempRow = [
                {
                    content: groupEmail.email
                },
                {
                    content: groupEmail.description,
                }
            ];
            rows.push(tempRow);
        });
        return { headers: this.contractorGroupEmailHeader, rows };
    }

    private addContractorGroupEmail = (addAnother: boolean) => () => {
        const { contractor, groupEmail, editingGroupEmail, rowIndex } = this.state;
        if (editingGroupEmail) {
            contractor.groupEmails[rowIndex] = groupEmail;
        } else {
            contractor.groupEmails.push(groupEmail);
        }
        if (addAnother) {
            this.setState({groupEmail: new GroupEmail(), contractor});
        } else {
            this.setState({editingGroupEmail: false, groupEmail: new GroupEmail(), groupEmailModal: false, contractor});
        }
    }

    private onEditGroupEmail = (index: number) => {
        this.setState({editingGroupEmail: true, groupEmail: DeepCopy(this.state.contractor.groupEmails[index]), groupEmailModal: true, rowIndex: index});
    }

    private toggleGroupEmail = () => {
        this.setState({groupEmailModal: !this.state.groupEmailModal});
    }

    private onDeleteGroupEmail = (index: number) => {
        const contractor = this.state.contractor;
        const groupEmail = contractor.groupEmails;
        groupEmail.splice(index, 1);
        this.setState({contractor});
    }

    private handleGroupEmailChange = (event: any) => {
        const groupEmail = this.state.groupEmail;
        groupEmail[event.target.name] = event.target.value;
        this.setState({groupEmail});
    }

    public handleChange(event: any) {
        const contractor = this.state.contractor;

        contractor[event.target.name] = event.target.value;

        this.setState({
            contractor,
            isDirty: true,
        });
    }

    public handleSaveContractor() {
        this.adminStore.saveContractor(this.state.contractor)
            .then(
                (data: any) => {
                    this.setState({
                        redirect: true
                    });

                    this.MessageStore.addMessage(
                        'Changes have been saved',
                        'success'
                    );
                },
                (error: any) => {
                    this.MessageStore.addMessage(
                        error.toString(),
                        'danger'
                    );
                }
            );
    }

    public removeContractor() {
        this.adminStore.deleteContractor(this.state.contractor)
            .then(
                (data: any) => {
                    this.setState({
                        redirect: true
                    });

                    this.MessageStore.addMessage(
                        'Contractor Successfully Deleted',
                        'success'
                    );
                }
            );
    }

    public render() {
        return(
            this.state.redirect ? (
                <Redirect to="/admin/contractors" />
            ) : (
                <div>
                    <Prompt when={this.state.isDirty} message={"Changes have been made.\n\nPress Cancel then Press Save OR Press OK to continue without saving."} />
                    <Row>
                        <Col md="6">
                            <FormGroup className="required">
                                <Label>Name</Label>
                                <EInput
                                    type="text"
                                    name="contractorName"
                                    required={true}
                                    value={this.state.contractor.contractorName}
                                    onChange={this.handleChange}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label>Erp Integration Id</Label>
                                <EInput
                                    type="text"
                                    name="erpId"
                                    value={this.state.contractor.erpId}
                                    disabled={true}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <DataTable
                                list={this.formatContractorGroupEmailsData()}
                                onNew={{
                                    callback: this.toggleGroupEmail,
                                    text: 'Add New Group Email'
                                }}
                                onEdit={this.onEditGroupEmail}
                                onDelete={this.onDeleteGroupEmail}
                            />
                        </Col>
                    </Row>
                    {
                        (this.state.contractor.id === '' ?
                        this.UserStore.hasPermission('Permissions.Admin.Categories.Create')
                        :
                        this.UserStore.hasPermission('Permissions.Admin.Categories.Update'))
                        &&
                        <ButtonRow>
                            <Button color="danger" onClick={this.removeContractor} >Delete Contractor</Button>
                            <EButton color="primary" onClick={this.handleSaveContractor}>Save Contractor</EButton>
                        </ButtonRow>
                    }
                    <Modal isOpen={this.state.groupEmailModal} toggle={this.toggleGroupEmail}>
                    <ModalHeader toggle={this.toggleGroupEmail}>
                        Add/Edit Group Email
                    </ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col>
                                <Label>Email</Label>
                                <EInput
                                    name="email"
                                    id="email"
                                    value={this.state.groupEmail.email}
                                    onChange={this.handleGroupEmailChange}
                                    data-validation="email"
                                    required={true}
                                />
                                <Label>Description</Label>
                                <EInput
                                    name="description"
                                    id="description"
                                    value={this.state.groupEmail.description}
                                    onChange={this.handleGroupEmailChange}
                                />
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button className="secondary" onClick={this.toggleGroupEmail}>Cancel</Button>
                        <EButton color="primary" onClick={this.addContractorGroupEmail(false)}>Save</EButton>
                        <EButton color="primary" onClick={this.addContractorGroupEmail(true)}>Add Another</EButton>
                    </ModalFooter>
                </Modal>
                </div>
            )
        );
    }
}

export default AdminContractorDetails;


// WEBPACK FOOTER //
// ./src/Components/Main/Admin/Contractors/AdminContractorDetails.tsx